import {createSlice} from '@reduxjs/toolkit'

export const bannerLatestVersion = 1

const dashboardBanner = createSlice({
  name: 'dashboardBanner',
  initialState: {
    version: bannerLatestVersion,
    isShown: true,
  },
  reducers: {
    toggleShowBanner(state, {payload}) {
      state.version = bannerLatestVersion
      if (payload == null) state.isShown = !state.isShown
      else state.isShown = payload
    },
  },
})

export const {toggleShowBanner} = dashboardBanner.actions
export default dashboardBanner
